module.exports = __webpack_public_path__ + "static/p4.8bc7d706.jpg";